import * as React from 'react';
import { ActionAfterViewObserver } from '@cian/action-after-viewed-component';
import { ArticleHeading2, ArticleParagraph1 } from '@cian/ui-kit';

import blackFridaySvg from './assets/blackFriday.svg';
import * as styles from './BlackFridayAppRedirectBanner.css';
import { NBSP } from '../../constants/symbols';
import { Section } from '../Section';

interface IBlackFridayAppRedirectBannerProps {
  onClick: () => void;
  onShow: () => void;
  url: string | undefined;
}

export const BlackFridayAppRedirectBanner: React.FC<IBlackFridayAppRedirectBannerProps> = ({
  onClick,
  onShow,
  url,
}) => {
  return (
    <Section data-testid="BlackFridayAppRedirectBannerSection">
      <ActionAfterViewObserver callback={onShow} wrapper={false}>
        <a className={styles['container']} href={url} onClick={onClick}>
          <img src={blackFridaySvg} className={styles['image']} />
          <div className={styles['content']}>
            <ArticleHeading2 color="current_color">Скидки переехали к нам</ArticleHeading2>
            <div className={styles['description-wrapper']}>
              <ArticleParagraph1 color="current_color">
                Эксклюзивные акции от{NBSP}застройщиков в{NBSP}приложении до{NBSP}29{NBSP}сентября
              </ArticleParagraph1>
            </div>
            <div>
              <button className={styles['button']}>
                <ArticleParagraph1 fontWeight="bold">Смотреть в приложении</ArticleParagraph1>
              </button>
            </div>
          </div>
        </a>
      </ActionAfterViewObserver>
    </Section>
  );
};
